import React from 'react'
import injectStyles from 'react-jss'
import styles from './styles'
import { formatFieldValue } from '../../../../Utils/Formatters'

const InfoRows = ({ data, classes }) => {
  if (!data) return null

  const items = data.map(({ name, value }, index) => (
    <div key={name + value + index} className={classes.row}>
      <span className={classes.name}>{name}:</span>
      <span className={classes.value}>{formatFieldValue(value)}</span>
    </div>
  ))

  return <section className={classes.wrapper}>{items}</section>
}

export default injectStyles(styles)(InfoRows)
